import React, { useContext, useEffect, useRef, useState } from 'react'
import { matchPath, NavLink, useLocation, useParams } from 'react-router-dom'
import routePathSegments, { routeNames } from '../../../routeSegments'
import axios from 'axios'
import { CompareCompanyContext } from '../../../Contexts/CompareCompanyContext'
import useModule from '../../../hooks/useModule'
import Constants from '../../../Constants'
import { getAdvisorDetails } from '../../../Config/config';
import { UserContext } from '../../../Contexts/UserContext';
import Loader from '../../Loader';
import AllAdvisorCosInvestments from './AllToInvestments';
import AllToExits from './AllToExits';
import ToAllInvestors from './ToAllInvestors';
import AllToAcquirers from './AllToAcquirer';
import { PeFilterContext } from '../../../Contexts/PeFilterContext';
import NewLogo from '../../NewLogo';


const AdvisorAllDetailPage = (props) => {
    const { companyId } = useParams();
    let advisorProfileId = parseInt(companyId)
    const location = useLocation();

    const [showModal, setShowModal] = useState(false);
    const [isActive, setIsActive] = useState(1);
    const { companyDetail, setCompanyDetail, setCurrentPage } = useContext(CompareCompanyContext);
    const { isStudent } = useContext(UserContext);
    const {primaryMasterId,isPE,isVC} = useModule();    
    const [note, setNote] = useState(false)
    const [showNote, setShowNote] = useState(false)
    const [open, setOpen] = useState()
    const [profileHighlights, setProfileHighlights] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState();
    const menuRef = useRef();
    const peMatch = matchPath(`${routePathSegments.pe}/*`, location.pathname);
    const { setMonthPickerValue } = useContext(PeFilterContext);

    const subTypeMasterId =() =>{
        if(isPE){ 
            if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_id){
            return Constants.subCategoryIds.pe_ladvisor_investments_id
            }
            else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_exits_id){
            return Constants.subCategoryIds.pe_ladvisor_exits_id
            }
            else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_ma_id){
            return Constants.subCategoryIds.pe_ladvisor_exitsma_id
            }
            else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_pm_id){
            return Constants.subCategoryIds.pe_tadvisor_exitspm_id
            }    
        }
        else if(isVC){
            if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_id){
                return Constants.subCategoryIds.vc_ladvisor_investments_id
                }
                else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_exits_id){
                return Constants.subCategoryIds.vc_ladvisor_exits_id
                }
                else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_ma_id){
                return Constants.subCategoryIds.vc_ladvisor_exitsma_id
                }
                else if(props?.section == Constants.primaryMasterSubIds.pe_vc_advisors_pm_id){
                return Constants.subCategoryIds.vc_ladvisor_exitspm_id
                }    
        }
    } 

    const getDetails = () => {
        axios.get(`${getAdvisorDetails}${advisorProfileId}/`).then(response => {
            if (response.status == 200) {
                setData(response.data);
                setProfileHighlights(response.data?.profile)

                setIsLoading(false);
                setOpen(false);
            }
        }).catch(error => {
            console.log(error);
            setIsLoading(false);
        })
    }

    useEffect(() => {
        getDetails()
    }, [advisorProfileId])

  return (
    <>
        {isLoading ?
            <div className="h-[10rem] w-full bg-[#FFFFFF] flex items-center justify-center">
                <Loader />
            </div>
            :
            <>
                <div className="bg-[#FFFFFF] relative">
                    <nav className="flex p-1 border-b " aria-label="Breadcrumb">
                        <ol role="list" className="flex items-center space-x-1">
                            <li className='flex items-center'>
                                <div className='flex items-center'>
                                    <NavLink to={location.state?.prevPath != null
                                        ? location.state?.prevPath
                                        : peMatch != null ? routeNames.PE_advisor : routeNames.VC_advisor} className="ml-1 text-[12pt] lg:text-[12px] text-[#666666]">
                                        Advisors</NavLink>
                                </div>
                            </li>
                            <li className='flex items-center'>
                                <div className="flex items-center">
                                    <span className=" text-[12px] text-[#666666] mr-1">/</span>
                                    <a className="text-[11pt] lg:text-[12px] text-[#666666] font-semibold"
                                        aria-current="page">{profileHighlights?.name ? profileHighlights?.name : "--"}</a>
                                </div>
                            </li>
                        </ol>
                    </nav>
                    {/* <!-- BarRaiser--> */}
                    {Object.keys(profileHighlights).length <= 0 ?
                        <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                            <center><div role="status" className="bg-white  h-[16rem]">
                                <svg className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                </svg>
                            </div></center>
                        </table>
                        :
                        <div className="pl-5 pr-3 ">
                            <div className=" pb-4 pt-6 bg-[#FFFFFF]">
                                <ul role="list" >
                                    <li className="w-full flex ">
                                        <div className=" rounded-md">
                                            <NewLogo
                                                name={profileHighlights?.name}
                                                id={advisorProfileId}
                                                menu="advisor"
                                                page="detail page"
                                            />
                                        </div>

                                        <div className="ml-3 flex flex-1 flex-col">
                                            <a className="text-[#333333] text-[22px] font-semibold leading-[24px]" href="#"> {profileHighlights?.name ? profileHighlights?.name : "--"} </a>
                                            <span className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body ">{profileHighlights?.advisor_type+" Advisor" ?? "--"}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    }
                </div>
                <div>
                    {props?.category === "investments" && <AllAdvisorCosInvestments companyInvestment={data?.to_cos} advisorName={data?.profile.name} menu={props.menu} advisorType={props?.advisorType} />}
                    {props?.category === "exits" && <AllToExits companyExits={data?.to_cos_exits} advisorName={data?.profile.name} menu={props.menu} advisorType={props?.advisorType} />}
                    {props?.category === "investors" && <ToAllInvestors toInvestor={data?.to_investors} advisorName={data?.profile.name} menu={props.menu} advisorType={props?.advisorType} />}
                    {props?.category === "acquirers" && <AllToAcquirers toAquirer={data?.to_acquirers} advisorName={data?.profile.name} menu={props.menu} advisorType={props?.advisorType} />} 
                </div>
            </>}
    </>
  )
}

export default AdvisorAllDetailPage